"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopover = void 0;
var react_1 = require("react");
var uuid_1 = require("uuid");
var triggerKeyDownHandler = function (event, setIsOpen) {
    switch (event.code) {
        case 'Space':
        case 'Enter':
            event.preventDefault();
            setIsOpen(true);
            break;
        case 'Escape':
            setIsOpen(false);
            break;
        default:
            break;
    }
};
var popoverKeyDownHandler = function (event, setIsOpen) {
    if (event.code === 'Escape') {
        setIsOpen(false);
    }
};
/**
 * Handles returning correct accessibility attributes and keyboard handlers for a popover
 * Also manages open close state of popover in controlled or uncontrolled mode
 **/
var usePopover = function (_a) {
    if (_a === void 0) { _a = {}; }
    var isOpenProp = _a.isOpen, setIsOpenProp = _a.setIsOpen, focusableElementRef = _a.focusableElementRef, id = _a.id, args = __rest(_a, ["isOpen", "setIsOpen", "focusableElementRef", "id"]);
    var previousIsOpen = (0, react_1.useRef)(undefined);
    var _b = (0, react_1.useState)(false), isOpenState = _b[0], setIsOpen = _b[1];
    var _c = (0, react_1.useState)(null), referenceElement = _c[0], setReferenceElement = _c[1];
    var popoverId = (0, react_1.useRef)(id !== null && id !== void 0 ? id : (0, uuid_1.v4)());
    var isOpen = isOpenProp !== null && isOpenProp !== void 0 ? isOpenProp : isOpenState;
    (0, react_1.useEffect)(function () {
        var _a;
        if (focusableElementRef && isOpen) {
            (_a = focusableElementRef.current) === null || _a === void 0 ? void 0 : _a.focus({
                preventScroll: true,
            });
        }
    }, [focusableElementRef, isOpen]);
    (0, react_1.useEffect)(function () {
        /**
         * If `previousIsOpen` is defined and does not match `isOpen`,
         * and if the popover was just closed, then focus the trigger element
         */
        if (previousIsOpen.current !== isOpen) {
            if (!isOpen && referenceElement) {
                referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.focus();
            }
        }
        previousIsOpen.current = isOpen;
    }, [isOpen, previousIsOpen, referenceElement]);
    var handleSetIsOpen = function (isOpen) {
        setIsOpen(isOpen);
        if (setIsOpenProp) {
            setIsOpenProp(isOpen);
        }
    };
    var triggerProps = args.triggerProps, popoverArgs = __rest(args, ["triggerProps"]);
    return {
        popoverTriggerProps: {
            ref: setReferenceElement,
            onClick: function (e) {
                if (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onClick) {
                    triggerProps.onClick(e);
                }
                handleSetIsOpen(!isOpen);
            },
            onKeyDown: function (e) {
                if (triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.onKeyDown) {
                    triggerProps.onKeyDown(e);
                }
                triggerKeyDownHandler(e, handleSetIsOpen);
            },
            'aria-expanded': isOpen,
            'aria-haspopup': true,
            'aria-controls': "popover-".concat(popoverId.current),
        },
        popoverProps: __assign(__assign({}, popoverArgs), { referenceElement: referenceElement, isOpen: isOpen, onClose: function (isOpen) { return handleSetIsOpen(isOpen); }, onKeyDown: function (e) {
                if (args.onKeyDown) {
                    args.onKeyDown(e);
                }
                popoverKeyDownHandler(e, handleSetIsOpen);
            }, id: "popover-".concat(popoverId.current) }),
    };
};
exports.usePopover = usePopover;
